const types = {
  FETCH_CONSIGNER_PAYMENT_DETAILS_START: 'FETCH_CONSIGNER_PAYMENT_DETAILS_START',
  FETCH_CONSIGNER_PAYMENT_DETAILS_SUCCESS: 'FETCH_CONSIGNER_PAYMENT_DETAILS_SUCCESS',
  FETCH_CONSIGNER_PAYMENT_DETAILS_FAILURE: 'FETCH_CONSIGNER_PAYMENT_DETAILS_FAILURE',
  FETCH_CONSIGNER_DOCUMENT_START: 'FETCH_CONSIGNER_DOCUMENT_START',
  FETCH_CONSIGNER_DOCUMENT_SUCCESS: 'FETCH_CONSIGNER_DOCUMENT_SUCCESS',
  FETCH_CONSIGNER_DOCUMENT_FAILURE: 'FETCH_CONSIGNER_DOCUMENT_FAILURE',
  INITIATE_CONSIGNER_PAYMENT_START: 'INITIATE_CONSIGNER_PAYMENT_START',
  INITIATE_CONSIGNER_PAYMENT_SUCCESS: 'INITIATE_CONSIGNER_PAYMENT_SUCCESS',
  INITIATE_CONSIGNER_PAYMENT_FAILURE: 'INITIATE_CONSIGNER_PAYMENT_FAILURE',
  INITIATE_CONSIGNER_PAYMENT_STATUS_START: 'INITIATE_CONSIGNER_PAYMENT_STATUS_START',
  INITIATE_CONSIGNER_PAYMENT_STATUS_SUCCESS: 'INITIATE_CONSIGNER_PAYMENT_STATUS_SUCCESS',
  INITIATE_CONSIGNER_PAYMENT_STATUS_FAILURE: 'INITIATE_CONSIGNER_PAYMENT_STATUS_FAILURE',
};
export default types;
